<template>
    <div>
        <div class="row">
            <div class="col-12">
                <g-table-sync
                    ref="app"
                    :app="app"
                    :view="view"
                    :columns="columns"
                    :default-limit="20"
                    pagination="loadmore"
                    @edit="openForm"
                >
                    <template slot="head-right" slot-scope="data">
                        <!-- Descargar Informe -->
                        <a-tooltip placement="top">
                            <template slot="title"> Generar informe de clientes </template>
                            <a-button class="mr-2" :loading="downloading" @click="getInforme">
                                <fa-icon class="mr-2" :icon="['fas', 'download']" />
                            </a-button>
                        </a-tooltip>
                    </template>
                    <template slot="legal_name" slot-scope="{ item }">
                        <truncate tag="span">
                            {{ item.legal_name }}
                        </truncate>
                    </template>
                    <template slot="alias" slot-scope="{ item }">
                        <truncate tag="span" class="clickable" @click="$router.push(`client/${item._EntityId}`)">
                            {{ item.alias }}
                        </truncate>
                    </template>
                    <template slot="address" slot-scope="{ item }">
                        <truncate tag="small">
                            {{ item.address }}<br />
                            {{ item.location ? item.location : '' }}
                            {{ item.state ? ', ' + item.state : '' }}
                        </truncate>
                    </template>

                    <template slot="actions" slot-scope="{ item }">
                        <g-item-actions app="clients" :item="item" @edit="openForm">
                            <template slot="left">
                                <a-button @click="$router.push({ name: 'clientInfo', params: { id: item._EntityId } })">
                                    <fa-icon :icon="['far', 'eye']" />
                                </a-button>
                            </template>
                        </g-item-actions>
                    </template>
                </g-table-sync>

                <!-- <app-list
					ref="app"
					:permalink="app"
					:view="view"
					:fields="columns"
					@edit="openForm"
				>
					<template
						slot="address"
						slot-scope="{item}"
					>
						<small>
							{{ item.address }}
							{{ item.location ? ', '+ item.location : '' }}
							{{ item.state ? ', '+ item.state : '' }}</small>
					</template>

				</app-list> -->
            </div>
        </div>

        <new-customer :id="id" ref="form" :app="app" :view="view" :visible="formEnabled" @close="closeForm" />
    </div>
</template>

<script>
import newCustomer from './form/index'

export default {
    name: 'Clients',
    components: { newCustomer },
    data() {
        return {
            app: 'clients',
            view: 'clientList',
            columns: [
                {
                    title: 'id',
                    index: '_EntityId',
                    order: true,
                    search: true,
                    width: '80px',
                },
                {
                    title: 'Alias',
                    index: 'alias',
                    slot: 'alias',
                    order: true,
                    search: true,
                },
                {
                    title: 'Razon Social',
                    index: 'legal_name',
                    slot: 'legal_name',
                    order: true,
                    search: true,
                },
                {
                    title: 'NIF/CIF',
                    width: '150px',
                    index: 'cif',
                    search: true,
                },
                {
                    title: 'Dirección',
                    index: 'address',
                    search: true,
                    slot: 'address',
                },
                {
                    title: 'Acciones',
                    width: '190px',
                    slot: 'actions',
                    align: 'right',
                },
            ],
            formEnabled: false,
            id: 0,
            downloading: false,
        }
    },
    created() {
        this.$hub.$on('newClient', () => {
            this.id = 0
            this.formEnabled = true
        })
    },
    beforeDestroy() {
        this.$hub.$off('newClient')
    },
    methods: {
        openForm(item) {
            this.$router.push(`client/${item._EntityId}?edit=1`)
        },
        closeForm() {
            this.id = 0
            this.formEnabled = false
        },
        async getInforme() {
            this.downloading = true

            try {
                const res = await this.$lambda.get(`/reports/${this.app}`, {
                    responseType: 'blob',
                })

                if (res.ok) {
                    const downloadUrl = window.URL.createObjectURL(res.data)
                    const a = document.createElement('a')
                    a.href = downloadUrl
                    a.download = 'reporteClientes.pdf'
                    document.body.appendChild(a)
                    a.click()
                    URL.revokeObjectURL(downloadUrl)

                    this.$message.success('Informe generado. Descargando fichero...')
                } else {
                    this.$message.error('No se pudo completar la operación')
                    throw String('No se pudo completar la operación')
                }
            } catch (err) {
                console.error(err)
                this.downloading = false
                this.$message.error('Ocurrió un error en la generación del informe')
            } finally {
                this.downloading = false
            }
        },
    },
}
</script>

<style lang="scss">
.clickable {
    cursor: pointer;
}
</style>
